export default __webpack_public_path__ + "static/media/img-0738-latvia-premium-face.d01cd055.png";